import { render, staticRenderFns } from "./NoteTypeSelectorModal.vue?vue&type=template&id=a802775e&"
import script from "./NoteTypeSelectorModal.vue?vue&type=script&lang=js&"
export * from "./NoteTypeSelectorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports